import { createHashHistory } from 'history';

export const history = createHashHistory();


// WEBPACK FOOTER //
// ./src/helpers/history.js